import {getContact} from "@/Services/contacts";

export default (contacts, state) => {
    return [
        {
            event: "Contacts\\ContactInvitationAccepted",
            callback: async (e: {contact: string; invitation: string}) => {
                if (state.type === "contacts") {
                    const {data} = await getContact(e.contact, {as: "contact"});
                    contacts.value.push(data);
                } else {
                    contacts.value = contacts.value.filter((c) => c.id !== e.invitation);
                }
            },
        },
        {
            event: "Invitations\\InvitationDeleted",
            callback: async (e: any) => {
                console.log("Invitations\\InvitationDeleted", e);
            },
        },
    ];
};
